export default __webpack_public_path__ + "static/media/Luigi 5.455dea0e.jpg";